import script from "./FuturesAppropriatenessRetakeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FuturesAppropriatenessRetakeModal.vue?vue&type=script&lang=ts&setup=true"

import "./FuturesAppropriatenessRetakeModal.vue?vue&type=style&index=0&id=246055ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246055ae"]])

export default __exports__